import { render, staticRenderFns } from "./personalHead.vue?vue&type=template&id=7b0cba02&scoped=true"
import script from "./personalHead.vue?vue&type=script&lang=js"
export * from "./personalHead.vue?vue&type=script&lang=js"
import style0 from "./personalHead.vue?vue&type=style&index=0&id=7b0cba02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0cba02",
  null
  
)

export default component.exports